import { Colors } from "@brg/ui";
import styled from "styled-components";

export const StatusTagsContainer = styled.div`
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
    width: 100%;
    overflow: visible;
    position: relative;
    z-index: 1;
`;

export const StatusTagItemWrap = styled.div`
    position: relative;
    display: inline-flex;
    overflow: visible;
`;

export const StatusTagItem = styled.div`
    display: flex;
    background-color: ${Colors.galBlack10};
    color: ${Colors.galBlack61};
    border-radius: 6px;
    font-size: 11px;
    line-height: 13px;
    padding: 2px 8px 4px 8px;
    cursor: default;
`;

export const StatusTagsHoverPopup = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 100;
    min-width: 200px;
    max-width: 360px;
    padding: 4px 0 0;
    pointer-events: auto;

    > * {
        padding: 12px;
        background: ${Colors.gallWhite};
        border: 1px solid ${Colors.galBlack10};
        border-radius: 8px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    }
`;
import { Colors } from "@brg/ui";
import styled from "styled-components";

export const StatusTagsContainer = styled.div`
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
    width: 100%;
    overflow: visible;
    position: relative;
    z-index: 1;
`;

export const StatusTagItemWrap = styled.div`
    position: relative;
    display: inline-flex;
    overflow: visible;
`;

export const StatusTagItem = styled.div`
    display: flex;
    background-color: ${Colors.galBlack10};
    color: ${Colors.galBlack61};
    border-radius: 6px;
    font-size: 11px;
    line-height: 13px;
    padding: 2px 8px 4px 8px;
    cursor: default;
`;

export const StatusTagsHoverPopup = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 100;
    min-width: 200px;
    max-width: 360px;
    padding: 4px 0 0;
    pointer-events: auto;

    > * {
        padding: 12px;
        background: ${Colors.gallWhite};
        border: 1px solid ${Colors.galBlack10};
        border-radius: 8px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    }
`;
